import React, { FC } from 'react'

import { Name } from 'components/designSystem/Name/Name'
import { Props } from 'components/designSystem/Typography/Typography'

import { StatusVariants } from '../StatusVariants/StatusVariants'

export const NameVariants: FC<
  {
    variant: 'inline-status' | 'footer-status'
    name: string
    age?: number | null
    isOnline?: boolean
    isVerified?: boolean
    size?: 'micro' | 'mini'
    singleLine?: boolean
    gap?: 4 | 8
  } & Props
> = ({
  variant = 'inline-status',
  name,
  age,
  isOnline,
  isVerified,
  size = 'mini',
  fontSize,
  fontWeight,
  singleLine = false,
  gap = 4,
  className,
}) => {
  switch (variant) {
    case 'inline-status':
      return (
        <Name
          className={className}
          name={name}
          age={age}
          fontSize={fontSize}
          fontWeight={fontWeight}
          statusInline={
            <StatusVariants
              size={size}
              isOnline={isOnline}
              isVerified={isVerified}
            />
          }
          singleLine={singleLine}
          gap={gap}
        />
      )

    case 'footer-status':
    default:
      return (
        <Name
          className={className}
          name={name}
          age={age}
          fontSize={fontSize}
          fontWeight={fontWeight}
          statusFooter={
            <StatusVariants
              size={size}
              isOnline={isOnline}
              isVerified={isVerified}
              variant={variant}
            />
          }
          singleLine={singleLine}
          gap={gap}
        />
      )
  }
}
